const mixins = {
  computed: {
    isLoginPageActive() {
      return this.$route.name === 'Init';
    },
  },

  methods: {
    getEnvironmentLayoutName() {
      const LAYOUT_BY_ENV = {
        volkswagen: 'VolkswagenLayout',
        audi: 'AudiLayout',
        seat: 'SeatLayout',
        cupra: 'CupraLayout',
      };

      return LAYOUT_BY_ENV[process.env.VUE_APP_BRAND];
    },

    formatMoney(amount) {
      if (!amount) return '0';

      return new Intl.NumberFormat('es-MX', { style: 'decimal', minimumFractionDigits: 2 }).format(amount);
    },
  },
};

export default mixins;
